import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../app/hooks';
import { selectStratigraphy, addStratigraphyLexicon } from '../../../services/stratigraphySlice';
import Container from './container';

const AddRole = ({}:any) => {    

    let history = useHistory();
    const dispatch = useAppDispatch();       

    const {  
        loading,
        saving,
        error
      } = useSelector(selectStratigraphy); 

    const onAddStratigraphyLexicon = (stratigraphyLexicon: any) => {        
        dispatch(addStratigraphyLexicon({...stratigraphyLexicon }))
        .unwrap()
        .then((response: any) => {
            toast.success("Successfully added stratigraphy lexicon");
            history.push(`/admin/stratigraphy/lexicon/list`) ;
         })
      };

    return (
       <Container title="Add Lexicon" 
                  onSave={onAddStratigraphyLexicon}
                  loading={loading}    
                  saving={saving}              
                  error={error} />
    )    
};

export default AddRole;